'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransactionStatus = exports.cancelUserWithdrawal = exports.getUserOnGoingTransactions = exports.deleteUserPaymentAccount = exports.getAvailablePaymentMethods = exports.getUserAvailablePaymentMethods = exports.getUserPaymentAccounts = undefined;

var _tgCoreDevcode = require('tg-core-devcode');

var _tgCoreDevcode2 = _interopRequireDefault(_tgCoreDevcode);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserPaymentAccounts = exports.getUserPaymentAccounts = function getUserPaymentAccounts(requestInfo) {
  return (0, _action.makeApiCallAction)('GET_USER_PAYMENT_ACCOUNTS', _tgCoreDevcode2.default.user.getUserPaymentAccounts, requestInfo);
};

var getUserAvailablePaymentMethods = exports.getUserAvailablePaymentMethods = function getUserAvailablePaymentMethods(requestInfo) {
  return (0, _action.makeApiCallAction)('GET_USER_AVAILABLE_PAYMENT_METHODS', _tgCoreDevcode2.default.user.getUserAvailablePaymentMethods, requestInfo);
};

var getAvailablePaymentMethods = exports.getAvailablePaymentMethods = function getAvailablePaymentMethods(requestInfo) {
  return (0, _action.makeApiCallAction)('GET_AVAILABLE_PAYMENT_METHODS', _tgCoreDevcode2.default.user.getAvailablePaymentMethods, requestInfo);
};

var deleteUserPaymentAccount = exports.deleteUserPaymentAccount = function deleteUserPaymentAccount(requestInfo) {
  return (0, _action.makeApiCallAction)('DELETE_USER_PAYMENT_ACCOUNT', _tgCoreDevcode2.default.user.deleteUserPaymentAccount, requestInfo);
};

var getUserOnGoingTransactions = exports.getUserOnGoingTransactions = function getUserOnGoingTransactions(requestInfo) {
  return (0, _action.makeApiCallAction)('GET_USER_ONGOING_TRANSACTIONS', _tgCoreDevcode2.default.user.getUserOnGoingTransactions, requestInfo);
};

var cancelUserWithdrawal = exports.cancelUserWithdrawal = function cancelUserWithdrawal(requestInfo) {
  return (0, _action.makeApiCallAction)('CANCEL_USER_WITHDRAW', _tgCoreDevcode2.default.user.cancelUserWithdrawal, requestInfo);
};

var getTransactionStatus = exports.getTransactionStatus = function getTransactionStatus(requestInfo) {
  return (0, _action.makeApiCallAction)('GET_TRANSACTION_STATUS', _tgCoreDevcode2.default.user.getTransactionStatus, requestInfo);
};

exports.default = {
  getUserPaymentAccounts: getUserPaymentAccounts,
  getUserAvailablePaymentMethods: getUserAvailablePaymentMethods,
  deleteUserPaymentAccount: deleteUserPaymentAccount,
  getUserOnGoingTransactions: getUserOnGoingTransactions,
  cancelUserWithdrawal: cancelUserWithdrawal,
  getAvailablePaymentMethods: getAvailablePaymentMethods,
  getTransactionStatus: getTransactionStatus
};